import Guid from '@/app/utils/guid'

export default class Folder {
  public id = Guid.empty()
  public name = ''
  public projectCount = 0
  public tenantId = Guid.empty()
}
